var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M12.355 7.15a2.645 2.645 0 1 1-1.607.544l.264.595a2.018 2.018 0 1 0 1.58-.499l-.286-.64h.05zm-9.659 0c.202 0 .399.023.588.066l-.36.573a2.018 2.018 0 1 0 1.419.838l.351-.565a2.645 2.645 0 1 1-1.998-.912z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EBCEC",
    fillRule: "nonzero",
    d: "M5.06 4.853h5.847l1.696 3.771a.5.5 0 0 1-.911.41L10.26 5.852H5.62L3.54 9.26a.5.5 0 0 1-.853-.522L5.06 4.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EBCEC",
    fillRule: "nonzero",
    d: "M4.082 3.67l.895-.447L7.2 7.67a.5.5 0 1 1-.894.447L4.082 3.67zm6.883-.248l.844.536-2.667 4.196a.5.5 0 1 1-.844-.536l2.667-4.196z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.686,
    cy: 3.656,
    r: 1,
    fill: "#2EBCEC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.778,
    cy: 3.223,
    fill: "#FFF",
    rx: 1.292,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.71,
    cy: 8.301,
    r: 1.151,
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycling);
export default __webpack_public_path__ + "static/media/cycling.5674f4e183c996fcbecc32f219809e80.svg";
export { ForwardRef as ReactComponent };